/* =========================================================
   Debellin — halaman /cart bergaya checkout + tombol checkout di cart drawer.
   Dimuat dari snippets/cart-drawer.liquid (semua halaman) dan sections/debellin-checkout.liquid.
   ========================================================= */
(function () {
  if (window.__dbcLoaded) return;
  window.__dbcLoaded = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${root}cart`;
  const MODE_KEY = 'dbc-mode-v1';

  const store = {
    get(k) {
      try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; }
    },
    set(k, v) {
      try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* abaikan */ }
    },
  };

  const postJSON = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

  /* ================= CART DRAWER: tombol Checkout -> /cart ================= */
  // Dipasang di window (capture) supaya jalan sebelum pencegat "Jadikan hadiah" di debellin-cart.js.
  window.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest && e.target.closest('#CartDrawer-Checkout');
      if (!btn) return;
      const addons = [...document.querySelectorAll('cart-drawer dc-addon.is-on')];
      if (addons.some((a) => a.isMissing)) return; // biar debellin-cart.js yang tampilkan error grafir
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      const dirty = addons.filter((a) => a.isDirty && typeof a.save === 'function');
      try { await Promise.all(dirty.map((a) => a.save())); } catch (err) { /* lanjut saja */ }
      window.location.href = cartUrl;
    },
    true
  );
  window.addEventListener('pageshow', () => {
    const btn = document.getElementById('CartDrawer-Checkout');
    if (btn) {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
    }
  });

  /* ================= PIN OTOMATIS PETA KIRIMINAJA =================
     Peta KA hanya memakai GPS perangkat di awal. Begitu customer memilih kelurahan (alamat baru, alamat orang
     lain, atau alamat tersimpan), titik peta dipindah ke kelurahan itu (geocoding OpenStreetMap), lalu customer
     tinggal menggeser untuk titik persisnya. Pin yang sudah digeser sendiri oleh customer tidak ditimpa. */
  const GEO_CACHE = 'dbc-geo-v1';
  const NEAR_KM = 2; // pin GPS dalam radius ini dari kelurahan terpilih dianggap sudah benar

  function distKm(a, b) {
    const R = 6371;
    const dLat = ((b.latitude - a.latitude) * Math.PI) / 180;
    const dLng = ((b.longitude - a.longitude) * Math.PI) / 180;
    const s =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((a.latitude * Math.PI) / 180) * Math.cos((b.latitude * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  function worldPx(p, z) {
    const r = 256 * 2 ** z;
    const s = Math.sin((Math.max(-85.05, Math.min(85.05, p.latitude)) * Math.PI) / 180);
    return { x: ((p.longitude + 180) / 360) * r, y: (0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * r };
  }

  const KA_DEFAULT = { latitude: -7.782926, longitude: 110.367246 }; // titik awal bawaan peta KA

  // Sejak update KA (Okt 2026) form KA digambar di dalam shadow DOM (div[data-kaj-host]).
  // querySelector biasa tidak bisa masuk ke sana, jadi cari di shadow root dulu, lalu di halaman biasa.
  function kaFind(sel, scope) {
    const base = scope || document;
    const hosts = base.querySelectorAll('[data-kaj-host]');
    for (const h of hosts) {
      const el = h.shadowRoot && h.shadowRoot.querySelector(sel);
      if (el) return el;
    }
    return base.querySelector(sel);
  }

  // Koordinat yang ditempel langsung: "-6.17, 106.83" atau link Google Maps versi lengkap.
  function parseLocation(text) {
    let t = String(text || '').trim();
    try { t = decodeURIComponent(t); } catch (e) { /* biarkan apa adanya */ }
    const pats = [
      /!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/, // titik tempat di link Google Maps
      /[?&](?:q|query|ll|destination)=(-?\d+\.\d+),\s*(-?\d+\.\d+)/,
      /@(-?\d+\.\d+),(-?\d+\.\d+)/, // tengah peta di link Google Maps
      /^(-?\d{1,2}\.\d+)\s*[,;\s]\s*(-?\d{2,3}\.\d+)$/, // koordinat polos
    ];
    for (const re of pats) {
      const m = t.match(re);
      if (!m) continue;
      const lat = parseFloat(m[1]);
      const lng = parseFloat(m[2]);
      if (lat > -12 && lat < 7 && lng > 94 && lng < 142) return { latitude: lat, longitude: lng };
    }
    return null;
  }
  const SHORT_LINK = /(maps\.app\.goo\.gl|goo\.gl\/maps|share\.google|g\.co\/kgs)/i;

  class KaPinSync {
    constructor(root) {
      this.root = root;
      this.gkey = ((root.closest('[data-dbc]') || {}).dataset || {}).gmapsKey || '';
      this.center = null; // titik tengah peta KA terakhir yang dilaporkan KA sendiri
      this.moving = null; // perpindahan yang sedang kita kerjakan (dicek ulang sampai pas)
      this.lastKey = '';
      this.userPinned = false;
      this.expectMove = 0; // jumlah perpindahan yang kita picu sendiri
      this.cache = (() => {
        try { return JSON.parse(sessionStorage.getItem(GEO_CACHE)) || {}; } catch (e) { return {}; }
      })();
      this.state = null; // isi form KA terakhir (event kaj:cart-state-change)
      document.addEventListener('kaj:mapLocationChanged', (e) => this.onMapChanged(e.detail || {}));
      window.addEventListener('kaj:address-resolved', () => this.onAddress());
      window.addEventListener('kaj:cart-state-change', (e) => {
        this.state = e.detail || null;
        this.onAddress();
      });
      // Cadangan kalau event KA tidak terkirim: cek berkala saat panel Instant terbuka.
      // Sekalian pastikan kolom "Cari lokasi" ada (form KA bisa menggambar ulang panelnya).
      this.ensureSearch();
      setInterval(() => {
        this.ensureSearch();
        this.onAddress();
      }, 1500);
    }

    /* ---------- Kolom "Cari lokasi" di atas peta ---------- */
    ensureSearch() {
      const field = this.q('#map-field-container');
      if (!field) return;
      this.ensureStyles(field);
      if (field.parentElement.querySelector('.dbc-pin-search')) return;
      const box = document.createElement('div');
      box.className = 'dbc-pin-search';
      box.innerHTML =
        '<label class="dbc-pin-search__label" for="dbc-pin-search-input">Cari lokasi</label>' +
        '<input id="dbc-pin-search-input" class="dbc-pin-search__input" type="search" autocomplete="off" ' +
        'placeholder="Nama jalan, gedung, masjid, minimarket…" aria-autocomplete="list" aria-controls="dbc-pin-results">' +
        '<ul id="dbc-pin-results" class="dbc-pin-search__results" role="listbox" hidden></ul>';
      field.insertAdjacentElement('beforebegin', box);
      const input = box.querySelector('input');
      const list = box.querySelector('ul');
      let timer;
      let seq = 0;
      this.searchResults = [];
      const close = () => {
        list.hidden = true;
        list.innerHTML = '';
      };
      const choose = async (r) => {
        if (!r || r.message) return;
        input.value = r.name;
        close();
        if (r.placeId && !Number.isFinite(r.latitude)) {
          const loc = await this.googleDetails(r.placeId);
          if (!loc) {
            this.hint('Lokasi tempat itu gagal diambil. Coba lagi, atau geser peta langsung.');
            return;
          }
          Object.assign(r, loc);
        }
        if (this.moveTo(r)) {
          this.userPinned = true; // pilihan customer sendiri: jangan ditimpa
          this.hint(
            r.direct
              ? 'Titik dipindah sesuai link / koordinat. Cek lagi di peta, geser sedikit kalau belum pas.'
              : `Titik dipindah ke ${r.name}. Geser peta sedikit kalau titik persisnya beda.`
          );
        }
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 3) return close();
        const showMessage = (text) => {
          this.searchResults = [];
          list.innerHTML = '';
          const li = document.createElement('li');
          li.className = 'dbc-pin-search__empty';
          li.textContent = text;
          list.appendChild(li);
          list.hidden = false;
        };
        const direct = parseLocation(q);
        if (direct) {
          seq += 1;
          this.searchResults = [
            { direct: true, name: 'Titik dari link / koordinat', detail: `${direct.latitude.toFixed(6)}, ${direct.longitude.toFixed(6)}`, ...direct },
          ];
        } else if (SHORT_LINK.test(q)) {
          seq += 1;
          return showMessage(
            'Link pendek belum bisa dibaca. Ketik nama tempatnya, atau buka link itu di Google Maps, tekan lama titiknya, salin koordinatnya, lalu tempel di sini.'
          );
        }
        timer = setTimeout(async () => {
          const my = ++seq;
          const results = direct ? this.searchResults : await this.searchPlaces(q);
          if (my !== seq) return; // sudah ada ketikan yang lebih baru
          this.searchResults = results;
          if (!results.length) {
            return showMessage('Tidak ketemu. Coba kata lain, tempel link Google Maps / koordinat, atau geser peta langsung.');
          }
          list.innerHTML = '';
          results.forEach((r, i) => {
            const li = document.createElement('li');
            li.setAttribute('role', 'option');
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'dbc-pin-search__item';
            const n = document.createElement('strong');
            n.textContent = r.name;
            const s = document.createElement('span');
            s.textContent = r.detail;
            b.append(n, s);
            b.addEventListener('mousedown', (e) => e.preventDefault()); // jangan hilangkan fokus dulu
            b.addEventListener('click', () => choose(this.searchResults[i]));
            li.appendChild(b);
            list.appendChild(li);
          });
          list.hidden = false;
        }, 350);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation(); // jangan sampai form KA ikut lanjut ke langkah berikutnya
          choose(this.searchResults[0]);
        } else if (e.key === 'Escape') {
          close();
        }
      });
      input.addEventListener('blur', () => setTimeout(close, 150));
    }

    // CSS halaman tidak berlaku di dalam shadow DOM KA: pasang ulang debellin-checkout.css di sana.
    ensureStyles(field) {
      const sr = field.getRootNode();
      if (!(sr instanceof ShadowRoot) || sr.querySelector('link[data-dbc-style]')) return;
      const src = [...document.querySelectorAll('link[rel="stylesheet"]')].find((l) => /debellin-checkout(\.min)?\.css/.test(l.href));
      if (!src) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = src.href;
      link.setAttribute('data-dbc-style', '');
      sr.appendChild(link);
    }

    // Cari tempat: Google Maps kalau ada API key (datanya paling lengkap), selain itu Photon/OpenStreetMap.
    // Hasil diurutkan dari yang terdekat dengan titik sekarang.
    async searchPlaces(q) {
      const bias = this.target || this.pin() || this.center || { latitude: -6.2, longitude: 106.82 };
      if (this.gkey) {
        const g = await this.googleSearch(q, bias);
        if (g && g.length) return g;
      }
      return this.photonSearch(q, bias);
    }

    async googleSearch(q, bias) {
      try {
        if (!this.gsession) this.gsession = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now());
        const r = await fetch('https://places.googleapis.com/v1/places:autocomplete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': this.gkey },
          body: JSON.stringify({
            input: q,
            includedRegionCodes: ['id'],
            languageCode: 'id',
            regionCode: 'id',
            sessionToken: this.gsession,
            locationBias: { circle: { center: { latitude: bias.latitude, longitude: bias.longitude }, radius: 50000 } },
            origin: { latitude: bias.latitude, longitude: bias.longitude },
          }),
        });
        if (!r.ok) return null;
        const j = await r.json();
        return (j.suggestions || [])
          .filter((s) => s.placePrediction)
          .slice(0, 6)
          .map((s) => {
            const p = s.placePrediction;
            const f = p.structuredFormat || {};
            return {
              placeId: p.placeId,
              name: (f.mainText && f.mainText.text) || (p.text && p.text.text) || q,
              detail: (f.secondaryText && f.secondaryText.text) || '',
            };
          });
      } catch (e) {
        return null;
      }
    }

    async googleDetails(placeId) {
      try {
        const token = this.gsession ? `?sessionToken=${encodeURIComponent(this.gsession)}` : '';
        this.gsession = null; // satu sesi pencarian selesai saat tempat dipilih
        const r = await fetch(`https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}${token}`, {
          headers: { 'X-Goog-Api-Key': this.gkey, 'X-Goog-FieldMask': 'location' },
        });
        if (!r.ok) return null;
        const j = await r.json();
        return j.location ? { latitude: +j.location.latitude, longitude: +j.location.longitude } : null;
      } catch (e) {
        return null;
      }
    }

    async photonSearch(q, bias) {
      try {
        const url =
          `https://photon.komoot.io/api/?limit=6&lang=default&lat=${bias.latitude}&lon=${bias.longitude}` +
          `&q=${encodeURIComponent(q)}`;
        const j = await fetch(url).then((r) => (r.ok ? r.json() : {}));
        return (j.features || [])
          .filter((f) => !f.properties.countrycode || f.properties.countrycode === 'ID')
          .map((f) => {
            const p = f.properties;
            const name = p.name || [p.street, p.housenumber].filter(Boolean).join(' ') || p.district || p.city || q;
            const detail = [p.name ? p.street : '', p.district || p.locality, p.city || p.county, p.state === 'Jawa' ? '' : p.state]
              .filter(Boolean)
              .filter((v, i, arr) => arr.indexOf(v) === i)
              .join(', ');
            return { name, detail, latitude: +f.geometry.coordinates[1], longitude: +f.geometry.coordinates[0] };
          });
      } catch (e) {
        return [];
      }
    }

    q(sel) {
      return kaFind(sel, this.root);
    }

    // Wilayah yang sedang dipilih di form KA. Sumber utama: event state KA (ikut berubah saat alamat tersimpan
    // dipilih); cadangan: hidden input data kelurahan.
    address() {
      let d = {};
      try { d = JSON.parse((this.q('input[name="attributes[sub_district_name]_data"]') || {}).value || '{}'); } catch (e) { /* abaikan */ }
      const st = this.state || {};
      return {
        prov: st.provinceName || d.provinceName || '',
        city: st.cityName || d.cityName || '',
        kec: st.districtName || d.districtName || '',
        kel: st.subDistrictName || d.subdistrictName || '',
        zip: st.postalCode || d.postalCode || (this.q('input[name="attributes[postal_code]"]') || {}).value || '',
      };
    }

    pin() {
      const lat = parseFloat((this.q('input[name="attributes[latitude]"]') || {}).value);
      const lng = parseFloat((this.q('input[name="attributes[longitude]"]') || {}).value);
      return Number.isFinite(lat) && Number.isFinite(lng) ? { latitude: lat, longitude: lng } : null;
    }

    onMapChanged(d) {
      const here = { latitude: +d.latitude, longitude: +d.longitude };
      const valid = Number.isFinite(here.latitude) && Number.isFinite(here.longitude);
      if (valid) this.center = here;
      if (this.expectMove > 0 && Date.now() - this.expectAt > 3000) this.expectMove = 0; // event tidak datang
      if (this.expectMove > 0 && d.source === 'camera-change') {
        this.expectMove -= 1;
        // Cek hasil geseran dengan posisi yang dilaporkan KA; kalau meleset, koreksi dari posisi sebenarnya.
        const m = this.moving;
        if (m && this.expectMove === 0 && valid) {
          if (distKm(here, m.target) > 0.02 && m.tries < 3) {
            m.tries += 1;
            this.drag(here, m.target);
          } else {
            this.moving = null;
          }
        }
        return;
      }
      // Customer menggeser peta atau menekan tombol lokasi: hormati pilihannya untuk alamat ini.
      if (d.source === 'camera-change' || d.source === 'geolocation') {
        this.userPinned = true;
        return;
      }
      // GPS otomatis KA datang terlambat dan menarik pin balik ke posisi perangkat: pindahkan lagi.
      if (d.source === 'auto-geolocation' && this.target && !this.userPinned) {
        const here = { latitude: +d.latitude, longitude: +d.longitude };
        if (distKm(here, this.target) > NEAR_KM) setTimeout(() => this.moveTo(this.target), 50);
      }
    }

    // Tunggu isian KA tenang dulu (alamat tersimpan diisi bertahap: kota dulu, lalu kecamatan & kelurahan).
    onAddress() {
      clearTimeout(this.addrTimer);
      this.addrTimer = setTimeout(() => this.syncAddress(), 700);
    }

    async syncAddress() {
      const a = this.address();
      if (!a.city) return;
      const key = [a.kel, a.kec, a.city, a.prov].join('|').toLowerCase();
      if (key === this.lastKey) return;
      this.lastKey = key;
      this.userPinned = false; // alamat berubah -> titik lama tidak berlaku lagi
      this.target = null;
      const target = await this.geocode(a);
      if (!target || this.lastKey !== key || this.userPinned) return;
      this.target = target;
      const cur = this.pin();
      // Titik yang kita pasang sendiri (mis. tengah kota sebelum kelurahan dipilih) selalu boleh dipindah lagi.
      const ours = cur && this.autoPin && distKm(cur, this.autoPin) < 0.05;
      if (cur && !ours && distKm(cur, target) <= NEAR_KM) {
        this.hint(`Titik sudah dekat ${a.kel || a.kec || a.city}. Geser peta kalau belum pas.`);
        return;
      }
      const area = a.kel ? `Kel. ${a.kel}` : a.kec ? `Kec. ${a.kec}` : a.city;
      if (this.moveTo(target)) {
        this.autoPin = target;
        this.hint(`Titik dipindah ke ${area}. Geser peta ke lokasi persis penerima.`);
      }
    }

    async geocode(a) {
      const city = a.city.replace(/^(kota|kabupaten|kab\.?)\s+/i, '');
      const queries = [
        a.kel ? [a.kel, a.kec, city, a.prov].filter(Boolean).join(', ') : '',
        a.kec ? [a.kec, city, a.prov].filter(Boolean).join(', ') : '',
        [city, a.prov].filter(Boolean).join(', '),
      ].filter(Boolean);
      for (const q of queries) {
        if (this.cache[q]) return this.cache[q];
        const hit = (await this.nominatim(q)) || (await this.photon(q));
        if (hit) {
          this.cache[q] = hit;
          try { sessionStorage.setItem(GEO_CACHE, JSON.stringify(this.cache)); } catch (e) { /* abaikan */ }
          return hit;
        }
      }
      return null;
    }

    async nominatim(q) {
      try {
        const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&countrycodes=id&limit=1&accept-language=id&q=${encodeURIComponent(q)}`;
        const j = await fetch(url).then((r) => (r.ok ? r.json() : []));
        return j[0] ? { latitude: +j[0].lat, longitude: +j[0].lon } : null;
      } catch (e) {
        return null;
      }
    }

    async photon(q) {
      try {
        const url = `https://photon.komoot.io/api/?limit=1&q=${encodeURIComponent(q + ', Indonesia')}`;
        const j = await fetch(url).then((r) => (r.ok ? r.json() : {}));
        const c = j.features && j.features[0] && j.features[0].geometry.coordinates;
        return c ? { latitude: +c[1], longitude: +c[0] } : null;
      } catch (e) {
        return null;
      }
    }

    // Peta KA tidak punya API: geser lewat event pointer, sama seperti customer menyeret peta.
    // Alamat tersimpan mengosongkan koordinat KA tanpa memindah peta, jadi posisi awal diambil dari
    // laporan KA terakhir, lalu hasilnya dicek ulang di onMapChanged dan dikoreksi kalau meleset.
    moveTo(target) {
      if (!this.mapEl()) return false;
      this.moving = { target: { latitude: target.latitude, longitude: target.longitude }, tries: 1 };
      // Koordinat kosong (mis. alamat tersimpan tanpa titik): KA mengembalikan peta ke titik bawaannya.
      // Kalau tebakan ini meleset (versi KA lain), onMapChanged mengoreksi dari posisi yang dilaporkan KA.
      return this.drag(this.pin() || KA_DEFAULT, target);
    }

    mapEl() {
      return this.q('#map-cart-customer-location') || this.q('.map-canvas');
    }

    drag(cur, target) {
      const map = this.mapEl();
      if (!map) return false;
      const tile = map.querySelector('img.kaj-slippy-map__tile');
      const z = Number(((tile && tile.src.match(/\/(\d+)\/\d+\/\d+\.png/)) || [])[1]) || 15;
      const a = worldPx(cur, z);
      const b = worldPx(target, z);
      const dx = a.x - b.x;
      const dy = a.y - b.y;
      const fire = (type, x, y) => {
        try {
          map.dispatchEvent(
            new PointerEvent(type, { bubbles: true, cancelable: true, button: 0, pointerId: 9173, isPrimary: true, clientX: x, clientY: y })
          );
        } catch (e) { /* setPointerCapture menolak pointer buatan; aman diabaikan */ }
      };
      this.expectMove += 1;
      this.expectAt = Date.now();
      fire('pointerdown', 0, 0);
      fire('pointermove', dx, dy);
      fire('pointerup', dx, dy);
      return true;
    }

    hint(text) {
      const field = this.q('#map-field-container') || this.q('.location-container');
      if (!field) return;
      let el = field.parentElement.querySelector('.dbc-pin-hint');
      if (!el) {
        el = document.createElement('p');
        el.className = 'dbc-pin-hint';
        field.insertAdjacentElement('afterend', el);
      }
      el.textContent = text;
    }
  }

  /* ================= HALAMAN /cart =================
     Satu form KiriminAja untuk dua pilihan pengiriman. Tab Reguler/Instant mengatur mode form KA:
     - Reguler = mode Express KA: tanpa peta, draft order KA -> checkout hanya menampilkan ekspedisi.
     - Instant = mode Instant KA: wajib titik peta -> checkout hanya menampilkan kurir instan sesuai titik.
     (Dibuktikan 27-28 Okt 2026: draft #D164 Instant hanya GoSend/GrabExpress; #D165/#D166 Express hanya ekspedisi.) */
  class DbcPage {
    constructor(el) {
      this.el = el;
      this.sectionId = el.dataset.sectionId;
      this.initMode();
      this.initSummary();
      this.initSummaryCollapse();
    }

    /* ---------- Mode Reguler / Instant ---------- */
    initMode() {
      const param = new URLSearchParams(window.location.search).get('kirim');
      const saved = store.get(MODE_KEY);
      // Keranjang berisi produk khusus Instant (shipping profile "Only Instant & Sameday"): Reguler dikunci.
      this.instantOnly = this.el.dataset.instantOnly === 'true';
      const mode = this.instantOnly
        ? 'instant'
        : param === 'instant' || param === 'reguler'
          ? param
          : saved === 'instant'
            ? 'instant'
            : 'reguler';
      this.el.querySelectorAll('[data-mode]').forEach((b) =>
        b.addEventListener('click', () => this.setMode(b.dataset.mode))
      );
      this.setMode(mode, true);
      this.mountKa();
    }

    setMode(mode, initial) {
      if (this.instantOnly && mode !== 'instant') return;
      this.mode = mode;
      if (!this.instantOnly) store.set(MODE_KEY, mode); // jangan ingat pilihan paksaan untuk keranjang berikutnya
      this.el.querySelectorAll('[data-mode]').forEach((b) => {
        const on = b.dataset.mode === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.el.querySelectorAll('[data-note]').forEach((n) => (n.hidden = n.dataset.note !== mode));
      this.syncKa();
      // Peta KA baru dibuat setelah mode Instant aktif: minta ukur ulang setelah tampil.
      if (mode === 'instant') setTimeout(() => window.dispatchEvent(new Event('resize')), 150);
      if (!initial) this.el.querySelector('.dbc-left').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Pindahkan blok app KiriminAja Cart ke kolom kiri.
    mountKa() {
      if (this.kaMounting) return;
      this.kaMounting = true;
      const mount = this.el.querySelector('[data-dbc-ka-mount]');
      const missing = this.el.querySelector('[data-dbc-ka-missing]');
      const tryMount = () => {
        const block = document.querySelector('.kaj-solid-cart-block');
        if (!block) return false;
        const appBlock = block.closest('.shopify-app-block') || block;
        if (!mount.contains(appBlock)) {
          const oldSection = appBlock.closest('.shopify-section');
          mount.appendChild(appBlock);
          if (oldSection && oldSection !== this.el.closest('.shopify-section')) oldSection.hidden = true;
        }
        missing.hidden = true;
        this.syncKa();
        if (!this.pinSync) this.pinSync = new KaPinSync(mount);
        if (!this.ioGuard) this.initInstantOnlyGuard();
        if (!this.kaTimer) {
          // Form KA ada di shadow DOM (MutationObserver tidak melihat isinya) dan bisa menggambar ulang
          // dirinya: jaga mode KA tetap sama dengan tab yang dipilih.
          this.kaTimer = setInterval(() => this.syncKa(), 1000);
        }
        return true;
      };
      if (tryMount()) return;
      // Blok KA dirender async: tunggu sebentar.
      let tries = 0;
      const iv = setInterval(() => {
        tries += 1;
        if (tryMount() || tries > 40) {
          clearInterval(iv);
          if (tries > 40 && !mount.querySelector('.kaj-solid-cart-block')) missing.hidden = false;
        }
      }, 250);
    }

    /* ---------- Penjaga jangkauan Instant & Same Day ----------
       Berlaku di tab Instant untuk SEMUA keranjang:
       - keranjang biasa: titik peta tidak boleh lebih jauh dari batas km Instant (kurir motor dari toko Jakarta);
       - keranjang produk khusus Instant (hampers/GrabCar): provinsi harus di daftar + batas km sendiri.
       Kalau tidak memenuhi, tombol "Lanjut ke Pembayaran" KA dikunci dan muncul pesan, supaya customer tidak baru
       ditolak di halaman pembayaran ("Shipping not available"). Tab Reguler tidak dicek. */
    initInstantOnlyGuard() {
      this.ioGuard = true;
      const ds = this.el.dataset;
      const norm = (v) => String(v || '').toLowerCase().replace(/[^a-z]/g, '');
      this.ioProvinces = String(ds.ioProvinces || '').split(',').map(norm).filter(Boolean);
      this.ioMaxKm = parseFloat(this.instantOnly ? ds.ioMaxKm : ds.instantMaxKm) || 0;
      const o = String(ds.ioOrigin || '').split(',').map((v) => parseFloat(v));
      this.ioOrigin = o.length === 2 && o.every(Number.isFinite) ? { latitude: o[0], longitude: o[1] } : null;
      this.ioNorm = norm;
      this.ioErrorEl = this.el.querySelector('[data-dbc-io-error]');
      this.ioNames = (this.el.querySelector('.dbc-banner--only strong') || {}).textContent || 'Produk ini';
      const check = () => this.checkInstantOnly();
      window.addEventListener('kaj:cart-state-change', () => setTimeout(check, 50));
      document.addEventListener('kaj:mapLocationChanged', () => setTimeout(check, 50));
      setInterval(check, 1000);
      // Tahan klik / Enter yang akan melanjutkan ke pembayaran selama alamat belum memenuhi syarat.
      const block = (e) => {
        if (!this.ioBlocked) return false;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.ioErrorEl && this.ioErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      };
      this.ioBound = new WeakSet();
      this.ioBind = () => {
        const host = this.el.querySelector('[data-kaj-host]');
        const root = (host && host.shadowRoot) || this.el;
        if (this.ioBound.has(root)) return;
        this.ioBound.add(root);
        root.addEventListener(
          'click',
          (e) => {
            if (!(e.target.closest && e.target.closest('#kaj-wizard-next'))) return;
            if (!block(e)) this.sendPin();
          },
          true
        );
        root.addEventListener(
          'keydown',
          (e) => {
            const t = e.target;
            if (e.key !== 'Enter' || !t || t.tagName === 'TEXTAREA' || (t.closest && t.closest('.dbc-pin-search'))) return;
            block(e);
          },
          true
        );
      };
      check();
    }

    // Server ongkir Instant Car (Cloudflare Worker) butuh titik peta: kirim titik + alamat + kode pos sebelum KA
    // membuat draft order. Shopify hanya meneruskan alamat teks ke server ongkir; server mencocokkan dari alamat ini.
    sendPin() {
      const endpoint = (this.el.dataset.instantCarUrl || '').replace(/\/+$/, '');
      if (!endpoint || !this.pinSync || !this.instantOnly) return; // server ongkir hanya untuk produk khusus Instant
      const pin = this.pinSync.pin();
      const addrEl = kaFind('#cart-customer-address');
      const zip = (kaFind('#kaj-input-zipcode') || {}).value || this.pinSync.address().zip || '';
      const address1 = addrEl ? addrEl.value : '';
      if (!pin || !address1 || !zip) return;
      const body = JSON.stringify({ address1, zip, lat: pin.latitude, lng: pin.longitude });
      try {
        const blob = new Blob([body], { type: 'text/plain' });
        if (!(navigator.sendBeacon && navigator.sendBeacon(`${endpoint}/pin`, blob))) {
          fetch(`${endpoint}/pin`, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
        }
      } catch (e) { /* tidak menghalangi checkout */ }
    }

    checkInstantOnly() {
      if (this.ioBind) this.ioBind();
      const a = this.pinSync ? this.pinSync.address() : {};
      const pin = this.pinSync ? this.pinSync.pin() : null;
      let msg = '';
      if (this.mode !== 'instant') {
        msg = ''; // tab Reguler: semua alamat boleh
      } else if (this.instantOnly && a.prov && this.ioProvinces.length && !this.ioProvinces.includes(this.ioNorm(a.prov))) {
        msg = `${this.ioNames} hanya bisa dikirim pakai GrabCar ke area Jabodetabek, belum bisa ke ${a.prov}. Ganti alamat penerima, atau hapus produk itu dari keranjang.`;
      } else if (a.city && pin && this.ioOrigin && this.ioMaxKm) {
        // Dicek setelah alamat dipilih: sebelum itu titik peta masih posisi GPS perangkat customer.
        const km = distKm(this.ioOrigin, pin);
        if (km > this.ioMaxKm) {
          msg = this.instantOnly
            ? `Titik penerima sekitar ${Math.round(km)} km dari toko, terlalu jauh untuk GrabCar (maks. ${this.ioMaxKm} km). Geser titik ke alamat yang benar, ganti alamat penerima, atau hapus ${this.ioNames} dari keranjang.`
            : `Instant & Same Day dikirim kurir dari toko kami di Jakarta, maksimal sekitar ${this.ioMaxKm} km. Titik penerima sekitar ${Math.round(km)} km dari toko, jadi pilih Reguler untuk alamat ini, atau geser titik kalau belum pas.`;
        }
      }
      this.ioBlocked = Boolean(msg);
      const btn = kaFind('#kaj-wizard-next');
      if (btn) {
        btn.style.opacity = msg ? '0.45' : '';
        btn.setAttribute('aria-disabled', msg ? 'true' : 'false');
      }
      if (this.ioErrorEl) {
        if (this.ioErrorEl.dataset.msg !== msg) {
          this.ioErrorEl.dataset.msg = msg;
          this.ioErrorEl.textContent = msg;
          // Keranjang biasa: beri tombol pindah ke Reguler.
          if (msg && !this.instantOnly) {
            const btn2 = document.createElement('button');
            btn2.type = 'button';
            btn2.className = 'dbc-io-error__switch';
            btn2.textContent = 'Pakai Reguler';
            // Gaya langsung di sini supaya tidak perlu mengubah debellin-checkout.css.
            btn2.style.cssText =
              'margin-left:.4rem;padding:.3rem 1rem;font:inherit;font-weight:600;color:#fff;background:rgb(var(--color-button,91,121,97));border:0;border-radius:6px;cursor:pointer';
            btn2.addEventListener('click', () => this.setMode('reguler'));
            this.ioErrorEl.append(' ', btn2);
          }
        }
        this.ioErrorEl.hidden = !msg;
      }
    }

    // Samakan mode form KA dengan tab: Reguler -> Express, Instant -> Instant.
    // Pilihan Express/Instant milik KA sendiri disembunyikan karena sudah diwakili tab kita.
    syncKa() {
      const express = kaFind('#delivery-type-express');
      const instant = kaFind('#delivery-type-instant');
      [express, instant].forEach((radio) => {
        if (!radio) return;
        const wrap = radio.closest('.kaj-radio') || radio.parentElement;
        // Sembunyikan wadah pilihan KA kalau jelas wadahnya; kalau struktur KA berubah, cukup tiap pilihan
        // (jangan sampai seluruh form ikut tersembunyi).
        const group = wrap && wrap.parentElement && /delivery-options/.test(wrap.parentElement.className) ? wrap.parentElement : wrap;
        if (group && group.style.display !== 'none') group.style.display = 'none';
      });
      const want = this.mode === 'instant' ? instant : express;
      if (want && !want.checked) want.click();
    }

    /* ---------- Ringkasan pesanan ---------- */
    initSummary() {
      this.el.addEventListener('click', (e) => {
        const qtyBtn = e.target.closest('[data-qty]');
        if (qtyBtn && this.el.contains(qtyBtn)) {
          const key = qtyBtn.closest('[data-key]').dataset.key;
          this.changeQty(key, Number(qtyBtn.dataset.qty));
          return;
        }
        if (e.target.closest('[data-dbc-voucher-apply]')) {
          this.applyVoucher();
          return;
        }
        const rm = e.target.closest('[data-dbc-code-remove]');
        if (rm) this.removeVoucher(rm.dataset.dbcCodeRemove);
      });
      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.matches('[data-dbc-voucher]')) {
          e.preventDefault();
          this.applyVoucher();
        }
      });
    }

    setBusy(on) {
      this.el.querySelector('[data-dbc-summary]').classList.toggle('is-busy', on);
    }

    async changeQty(key, qty) {
      this.setBusy(true);
      try {
        const cart = await postJSON(`${root}cart/change.js`, { id: key, quantity: Math.max(0, qty) });
        if (!cart.item_count) {
          window.location.reload();
          return;
        }
        await this.refreshSummary();
      } catch (e) {
        window.location.reload();
      } finally {
        this.setBusy(false);
      }
    }

    async currentCodes() {
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      return { cart, codes: (cart.discount_codes || []).map((d) => d.code) };
    }

    async applyVoucher() {
      const input = this.el.querySelector('[data-dbc-voucher]');
      const code = input.value.trim();
      if (!code) return;
      this.setBusy(true);
      try {
        const { codes } = await this.currentCodes();
        const next = [...new Set([...codes, code])].join(',');
        const cart = await postJSON(`${root}cart/update.js`, { discount: next });
        const hit = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        await this.refreshSummary();
        if (!hit || !hit.applicable) {
          // Kode tidak berlaku: buang lagi supaya tidak menempel di cart.
          await postJSON(`${root}cart/update.js`, { discount: codes.join(',') });
          await this.refreshSummary();
          this.voucherMsg('Kode voucher tidak berlaku untuk keranjang ini.', true);
        } else {
          this.voucherMsg('Kode voucher dipakai.', false);
        }
      } catch (e) {
        this.voucherMsg('Gagal memakai kode, coba lagi.', true);
      } finally {
        this.setBusy(false);
      }
    }

    async removeVoucher(code) {
      this.setBusy(true);
      try {
        const { codes } = await this.currentCodes();
        // Chip memakai judul dari discount_applications (huruf besar, mis. "AFFILIATE"),
        // sedangkan cart.discount_codes menyimpan kode persis seperti diketik ("affiliate").
        // Bandingkan tanpa peduli huruf besar/kecil supaya kodenya benar-benar terhapus.
        const target = String(code).toLowerCase();
        await postJSON(`${root}cart/update.js`, {
          discount: codes.filter((c) => c.toLowerCase() !== target).join(','),
        });
        await this.refreshSummary();
        const msg = this.el.querySelector('[data-dbc-voucher-msg]');
        if (msg) msg.hidden = true;
      } catch (e) {
        this.voucherMsg('Gagal menghapus kode, coba lagi.', true);
      } finally {
        this.setBusy(false);
      }
    }

    voucherMsg(text, isError) {
      const msg = this.el.querySelector('[data-dbc-voucher-msg]');
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('is-error', isError);
      msg.hidden = false;
    }

    async refreshSummary() {
      const html = await fetch(`${cartUrl}?section_id=${encodeURIComponent(this.sectionId)}`).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-dbc-summary]');
      const current = this.el.querySelector('[data-dbc-summary]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const total = doc.querySelector('.dbc-summary-toggle__total');
      const curTotal = this.el.querySelector('.dbc-summary-toggle__total');
      if (total && curTotal) curTotal.textContent = total.textContent;
      // Ikon jumlah di header ikut diperbarui
      const count = doc.querySelector('[data-dbc]');
      if (count) document.dispatchEvent(new CustomEvent('dbc:cart-updated', { detail: { count: count.dataset.itemCount } }));
      // Produk khusus Instant baru masuk / sudah dihapus: muat ulang supaya pilihan Reguler ikut menyesuaikan.
      if (count && count.dataset.instantOnly !== this.el.dataset.instantOnly) window.location.reload();
    }

    // Di HP ringkasan bisa dilipat; di desktop selalu terbuka.
    initSummaryCollapse() {
      const wrap = this.el.querySelector('[data-dbc-summary-wrap]');
      if (!wrap) return;
      const mq = window.matchMedia('(min-width: 990px)');
      const apply = () => {
        if (mq.matches) wrap.open = true;
      };
      if (!mq.matches) wrap.open = false;
      mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
      wrap.querySelector('summary').addEventListener('click', (e) => {
        if (mq.matches) e.preventDefault();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-dbc]').forEach((el) => {
      if (!el.__dbc && el.querySelector('[data-dbc-ka-mount]')) el.__dbc = new DbcPage(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
